import { Provider } from "react-redux";
import { Suspense, useEffect } from "react";
import { BrowserRouter as Router } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import store from "./store";
import "react-toastify/dist/ReactToastify.css";

// project css
import "./assets/scss/_style.scss";
import App from "./container/app";
import { getFromLocalStorage } from "./helpers";
import ScrollToTop from "./component/user/scrollToTop/ScrollToTop";
import Loading from "./reusable/Loading/Loading";

const MainApp = () => {
  const toastOptions = {
    position: "top-right",
    autoClose: 4000,
    hideProgressBar: false,
    newestOnTop: false,
    closeOnClick: true,
    rtl: false,
    pauseOnFocusLoss: true,
    draggable: true,
    pauseOnHover: true,
  };
  return (
    <Suspense fallback={<Loading loading={true} fallback={true} />}>
      <Provider store={store}>
        <Router>
          <ToastContainer {...toastOptions} />
          <ScrollToTop>
            <App />
          </ScrollToTop>
        </Router>
      </Provider>
    </Suspense>
  );
};

export default MainApp;
